import { useEffect, useState } from "react";
import { HbrCancel } from "../newComponents/Mycustomsvgicons";

const WiderImageView = ({imageUrl, handleCloseView}) => {
    const [isImageUrlValid, setImageUrlValid] = useState(true);

    useEffect(()=>{
        const img = new Image();
        img.src = imageUrl;
        img.onload = () => setImageUrlValid(true);
        img.onerror = () => setImageUrlValid(false);

    },[imageUrl]);


    return ( 
    <div className="widerimageView" style={{
        width:"100%",
        height:"100vh",
        position:"fixed",
        top:"0px",
        left:"0px",
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
        background:"#1a1a1a",
        zIndex:"2"
    }}>
        {isImageUrlValid ? 
        ( <img src={imageUrl} alt=""/>)
        :
        (<h2>Failed to load image</h2>)
        }
        <div style={{position:"absolute", right:"1em", top:"1em"}}>
        <HbrCancel width={"1.7em"} height={"1.7em"} fillColour={"#ffffff"} handleClick={()=>handleCloseView()}/>
        </div>
        
    </div>
     );
}
export default WiderImageView;